import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"



import Header from "./content/header"

class AddMatriculaAdm extends Component {

state= {
  matricula:[],
  idmatricula:null,
  precoinscricao:0.00,
  status:0,
  error:null,
  paid:false,
  success:null,
  aluno:null,
  cursos:[],
  idcurso:"",
  primeirafaturagerada:"",
  datacobranca:"",
  mensalidade:"",
  mensalidadedesconto:"",
  qtdparcelas:"",
  codturma:"",
  observacao:null,
  alunos:[],
  idaluno:null,
  indicacao:null,
  isead:0
}

    async componentDidMount(){

      this.loadcursos();
      this.loadalunos('');

    }

    async loadalunos(search_val){
      this.setState({
        alunos:[],
        loaded:false
      })
      let search;
      if(search_val==null){
        search = this.state.search;
      }else{
        search =search_val;
      }
      const response = await api.post("/admin/users", {search});
  
      if(response.data){
        this.setState({
          alunos:response.data.success,
          loaded:true
        })
      }
      
    }


    async loadcursos () {
      const response = await api.get("/cursosadm");
      this.setState({ cursos: response.data });
    }
 



  addmatricula = async e => {
    e.preventDefault();
    const { idaluno, precoinscricao, status, paid, idcurso, codturma,
      mensalidade,mensalidadedesconto, datacobranca,qtdparcelas,observacao,indicacao,isead } = this.state;
      if (!idaluno || !precoinscricao || !idcurso || !mensalidade || !mensalidadedesconto || !datacobranca || !qtdparcelas || !codturma) {
          this.setState({ error: "Preencha os dados antes de editar!",
        success:null });
          
      } else {
      const { idaluno, precoinscricao, status, paid, idcurso,isead } = this.state;
      const response = await api.post("/admin/matriculas/add", {observacao,isead,codturma,qtdparcelas,mensalidade,mensalidadedesconto, datacobranca, idcurso, precoinscricao, status, paid,idaluno,indicacao });

        if(response.data.id){
          this.setState({ success: "Matricula Cadastrada!" , error:null,nome:null });
        }

      }
  }

  compare( a, b ) {
    if ( a.nomecompleto < b.nomecompleto ){
      return -1;
    }
    if ( a.nomecompleto > b.nomecompleto ){
      return 1;
    }
    return 0;
  }

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Adicionar Matricula</h4>     
        <form onSubmit={this.addmatricula}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                  
                    <label for="exampleFormControlInput1">Aluno</label>
                    <select class="browser-default custom-select"  onChange={e => this.setState({ idaluno: e.target.value })} >
                    <option>Selecione um valor</option>

                    {this.state.alunos.sort( this.compare ).map(el => (
                      
                      <option value={el.id} selected={this.state.idaluno==el.id}>{el.nomecompleto} </option>
                      
                    ))}
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Curso</label>
                    <select class="browser-default custom-select"  onChange={e => this.setState({ idcurso: e.target.value })} >

                    <option>Selecione um valor</option>

                    {this.state.cursos.map(el => (
                      
                      <option value={el.id} selected={this.state.idcurso==el.id}>{el.nome} | Unidade ID #{el.idunidade}  </option>
                      
                    ))}
                    </select>
                </div>

                <div class="form-group">
                  <label for="exampleFormControlInput1">Código Turma</label>
                  <input type="text" class="form-control" defaultValue={this.state.codturma} onChange={e => this.setState({ codturma: e.target.value })} />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Inscrição</label>
                    <input type="text" class="form-control" defaultValue={this.state.precoinscricao} onChange={e => this.setState({ precoinscricao: e.target.value })} />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade </label>
                    <input type="text" class="form-control" defaultValue={this.state.mensalidade} onChange={e => this.setState({ mensalidade: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade com Desconto</label>
                    <input type="text" class="form-control" defaultValue={this.state.mensalidadedesconto} onChange={e => this.setState({ mensalidadedesconto: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Quantidade Parcelas </label>
                    <input type="text" class="form-control" defaultValue={this.state.qtdparcelas} onChange={e => this.setState({ qtdparcelas: e.target.value })} />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlInput1">Cobrar 1º a partir de</label>
                  <input type="date" class="form-control" defaultValue={this.state.datacobranca} onChange={e => this.setState({ datacobranca: e.target.value })} />
                </div>
                


                <div class="form-group">
                    <label for="exampleFormControlInput1">Pagamento</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ paid: e.target.value })}>
                      <option value="1" selected={this.state.paid==true}>Efetuado</option>
                      <option value="0" selected={this.state.paid==false}>Não Efetuado</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Modalidade</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ isead: e.target.value })}>
                      <option value={1} selected={this.state.isead==1}>EAD</option>
                      <option value={0} selected={this.state.isead==0}>Presencial</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Status</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ status: e.target.value })} >
                      <option value="0" selected={this.state.status==0}>Pendente</option>
                      <option value="1" selected={this.state.status==1}>Ativa</option>
                      <option value="2" selected={this.state.status==2}>Cancelada</option>
                      <option value="4" selected={this.state.status==4}>Concluída</option>
                      <option value="5" selected={this.state.status==5}>Concluída com Pendência</option>
                      <option value="6" selected={this.state.status==6}>Formado</option>
                      <option value="7" selected={this.state.status==7}>Ativa Totalmente Paga</option>
                    </select>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlInput1">Observação</label>
                  <textarea rows="5" cols="70" onChange={e => this.setState({ observacao: e.target.value })} 
               class="form-control" value={this.state.observacao}
                >
                  
                </textarea>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Indicação </label>
                    <input type="text" class="form-control" defaultValue={this.state.indicacao} onChange={e => this.setState({ indicacao: e.target.value })} />
                </div>


                <div class="form-group">
                <button class="btn btn-primary mb-2">Matricular</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(AddMatriculaAdm);


// WEBPACK FOOTER //
// ./src/pages/Admin/addmatricula.js